import Vue from 'vue'
import Router from 'vue-router'

import EditConfigHome from './views/EditConfigHome'

import Setup from '@/views/Setup'
import AdminTab from '@/views/AdminTab'
import Navigation from '@/views/Navigation'
import ScanResultTab from '@/views/ScanResultTab'
import EditorTab from '@/views/EditorTab'
import DesignTab from '@/views/DesignTab'
import FooterConsentTab from '@/views/FooterConsentTab'
import GlobalTab from '@/views/GlobalTab'
import RedirectTab from '@/views/RedirectTab'
import AuthAppBrandingTab from '@/views/AuthAppBrandingTab'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/config/:id/',
      name: 'edit-config',
      component: EditConfigHome,
      children: [
        {
          name: 'redirect',
          path: 'redirect',
          components: {
            tab: RedirectTab,
            navigation: Navigation
          },
          props: { navigation: { selected: 'REDIRECT', mode: 'remote' } }
        },
        {
          name: 'config-scan-result',
          path: 'scan-result',
          components: {
            tab: ScanResultTab,
            navigation: Navigation
          },
          props: { navigation: { selected: 'SCAN-RESULT', mode: 'remote' } }
        },
        {
          name: 'config-editor',
          path: 'editor',
          components: {
            tab: EditorTab,
            navigation: Navigation
          },
          props: { navigation: { selected: 'EDITOR', mode: 'remote' } }
        },
        {
          name: 'config-design',
          path: 'design',
          components: {
            tab: DesignTab,
            navigation: Navigation
          },
          props: { navigation: { selected: 'DESIGN', mode: 'remote' } }
        },
        {
          name: 'config-footer-consent',
          path: 'footer-consent',
          components: {
            tab: FooterConsentTab,
            navigation: Navigation
          },
          props: { navigation: { selected: 'FOOTER-CONSENT', mode: 'remote' } }
        },
        {
          name: 'config-auth-app-branding',
          path: 'auth-app-branding',
          components: {
            tab: AuthAppBrandingTab,
            navigation: Navigation
          },
          props: { navigation: { selected: 'AUTH-APP-BRANDING', mode: 'remote' } }
        },
        {
          name: 'config-global',
          path: 'global',
          components: {
            tab: GlobalTab,
            navigation: Navigation
          },
          props: { navigation: { selected: 'GLOBAL', mode: 'remote' } }
        },
        {
          name: 'config-admin',
          path: 'admin',
          components: {
            tab: AdminTab,
            navigation: Navigation
          },
          props: { navigation: { selected: 'ADMIN', mode: 'remote' } }
        }
      ]
    },
    {
      path: '/setup/:id',
      name: 'setup',
      component: Setup
    }
  ]
})
